// extracted by mini-css-extract-plugin
export default {"inner_side_cell":"InnerSideCell_inner_side_cell__96O5f","active":"InnerSideCell_active__-JYkP"};